import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  flightListData: {},
  isLoading: true,
  error: "",
  hasData: false
};
const flightListSlice = createSlice({
  name: "flightList",
  initialState,
  reducers: {
    getFlightListDataPending: state => {
      state.isLoading = true;
    },
    getFlightListDataSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.flightListData = action.payload;
    },
    getFlightListDataError: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    }
  }
});
export const {
  getFlightListDataPending,
  getFlightListDataSuccess,
  getFlightListDataError
} = flightListSlice.actions;
export default flightListSlice.reducer;